import React from "react";

import { SvgComponentProps } from "../GenericIconType";
import { SvgWrapper } from "../styles";

const Search = (props: SvgComponentProps) => {
  const { width = 16, height = 16, color = "#667085", widthBoxView, heightBoxView } = props;

  return (
    <SvgWrapper>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${widthBoxView || width} ${heightBoxView || height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
          stroke={color}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 14L11.1 11.1"
          stroke={color}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgWrapper>
  );
};

export default Search;
